var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3600 3600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6fcbd0;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1800,0C807.47,0,0,807.48,0,1800s807.47,1800,1800,1800,1800-807.48,1800-1800S2792.53,0,1800,0ZM1800,3355.58c-857.75,0-1555.58-697.83-1555.58-1555.58S942.25,244.42,1800,244.42s1555.58,697.83,1555.58,1555.58-697.83,1555.58-1555.58,1555.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1177.5,2635.17c-713.17-534.88-361.52-1186.47-346.21-1213.95,28.03-49.86,10.48-113.05-39.34-141.28-49.89-28.31-113.3-10.75-141.59,39.16-4.85,8.57-119.01,213.17-125.79,498.05-6.27,263.54,80.28,648.21,528.28,984.21,18.68,14.02,40.55,20.78,62.24,20.78,31.58,0,62.78-14.34,83.18-41.56,34.42-45.89,25.13-111.01-20.78-145.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/Bubble.bae34df03670bd27ee36854e2fd5358e.svg";
export { ForwardRef as ReactComponent };